import React, { useState, useEffect } from "react";
import ItemsPerPage from "./ItemsPerPage";
import QuerySummary from "./QuerySummary";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import Pagination from "./Pagination";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { eventWrapper } from "@testing-library/user-event/dist/utils";

const FinderTable = (props) => {
  const windowSize = window.innerWidth;
  if (props.config.removeControls ){
    props.config.itemsPerPageArray=[props.jsonTable.length];
  }
  const [numberItems, setNumberItems] = useState(windowSize < 640 ? props.config.defaultItemsPerPageMobile || props.config.itemsPerPageArray[0] : props.config.defaultItemsPerPage || props.config.itemsPerPageArray[0]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState(0);
  const [table, setTable] = useState([...props.jsonTable]);
  const [totalItems, setTotalItems] = useState(props.jsonTable.length);
  const [seed, setSeed] = useState(1);

  const onSearchValueChange = (item) => {
    if (item) {
      if (item.name) {
        setSearchValue(item.name);
      } else {
        setSearchValue(item);
      }
    } else {
      setSearchValue("");
    }
    setCurrentPage(1);
  };

  useEffect(() => {
    if (searchValue) {
      let clonedTable = JSON.parse(JSON.stringify(props.jsonTable));
      setTable(
        clonedTable.filter((row) => {
          return row.some((cell) => {
            if (
              cell?.v
                ?.toString()
                .toLowerCase()
                .includes(searchValue.toLowerCase())
            ) {
              cell.H = 1;
              return true;
            }
            return false;
          });
        })
      );
    } else {
      setTable([...props.jsonTable]);
    }
  }, [searchValue]);

  useEffect(() => {
    setTotalItems(table.length);
  }, [table]);

  useEffect(() => {
    if (sortBy) {
      table.sort((a, b) => {
        let aVal = a[sortBy.col]?.w || "";
        let bVal = b[sortBy.col]?.w || "";

        aVal= new Date(aVal).getTime() || aVal;
        bVal= new Date(bVal).getTime() || bVal;
        if (aVal < bVal) {
          return sortBy.direction === "asc" ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortBy.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
      setSeed(Math.random());
    } else if (sortBy === null) {
      table.sort((a, b) => {
        const aVal = a[0]?.id || "";
        const bVal = b[0]?.id || "";
        return aVal < bVal ? -1 : 1;
      });
      setSortBy(0);
    }
  }, [sortBy, table]);

  useEffect(() => {
    totalPages() < currentPage && setCurrentPage(totalPages());
  }, [numberItems]);

  const onItemsPerPageChange = (event) => {
    setNumberItems(event.target.value);
  };

  const totalPages = () => {
    return Math.ceil(totalItems / numberItems);
  };
  const goToFirstPage = () => {
    setCurrentPage(1);
  };
  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const goToPage = (events) => {
    if (events.target.value > 0 && events.target.value <= totalPages()) {
      setCurrentPage(events.target.value);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages()) {
      setCurrentPage(parseInt(currentPage) + 1);
    }
  };
  const goToLastPage = () => {
    setCurrentPage(totalPages());
  };
  return (
    <div className={`finderTable-wrapper ${props.config.removeControls ? 'finderTable-no-controls' : ''}`}>
      {!props.config.removeControls && <div className="finderTable-header">
        <ReactSearchAutocomplete
          items={props.fuzeTable}
          placeholder={window.finderTable.dict.searchboxPlaceHolder}
          onSelect={onSearchValueChange}
          onClear={onSearchValueChange}
          onSearch={onSearchValueChange}
          styling={{ borderRadius: "3px" ,color:"#444444",placeholderColor:"#7e7e7e",iconColor:"#000"}}
        />
        <ItemsPerPage
          config={props.config}
          elBinding={numberItems}
          onChange={onItemsPerPageChange}
        />
        {totalItems && (
          <QuerySummary
            totalItems={totalItems}
            numberItems={numberItems}
            currentPage={currentPage}
          />
        )}
      </div>}
      <div className="finderTable-table-wrapper">
      <div className={`finderTable-table ${props.config.numberColsVisible ? 'finderTable-hidden-columns': ''}`}>
        <TableHeader
          config={props.config}
          sortBy={sortBy}
          onSort={setSortBy}
          header={props.jsonHeader}
        />
        <TableBody
          key={seed}
          config={props.config}
          numberItems={numberItems}
          currentPage={currentPage}
          header={props.jsonHeader}
          table={table}
        />
        
        {!totalItems && (
          <div className="filterable-table-no-searchresults">
            {window.finderTable.dict.noSearchResults}
          </div>
        )}
      </div>
      </div>

      
      {!props.config.removeControls && totalItems && (
          <Pagination
            totalPages={totalPages()}
            currentPage={currentPage}
            onPagination={{
              first: goToFirstPage,
              prev: goToPrevPage,
              next: goToNextPage,
              last: goToLastPage,
              page: goToPage,
            }}
          />
        )}
    </div>
  );
};

export default FinderTable;
